import React from 'react'
import cn from 'classnames'

import Spinner from 'components/common/elements/Spinner'

import styles from '../Styles.scss'

const Button = ({ children, reverse, mini, text, active, action, className, ...other }) => (
  <button className={cn(styles.Button, {
            [className]: className,
            [styles.Reverse]: reverse,
            [styles.Mini]: mini,
          })}
          disabled={active}
          role='button'
          {...other}
  >
    { children || text }
    { active && <Spinner size={mini ? 20 : 36}/> }
  </button>
)

export default Button
